/* unplugin-vue-components disabled */import { render } from "./comp5.vue?vue&type=template&id=6957efe4&scoped=true"
import script from "./comp5.vue?vue&type=script&lang=js"
export * from "./comp5.vue?vue&type=script&lang=js"

import "./comp5.vue?vue&type=style&index=0&id=6957efe4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6957efe4"]])

export default __exports__